<template>
	<div class="login-container">
		<div class="top" @click.stop="onCreateDesign" :style="{'background-image':setting.login_background_image && is_login ? `url(${setting.login_background_image})` : `url(${require('../../assets/images/login-top-bg.jpg')})`}">
			<div v-if="is_login" class="slogan-box">
				<div class="slogan-container">
					<img src="../../assets/images/slogan-large.png" alt="" class="slogan-img">
					<div class="diy-btn" @click.stop="onCreateDesign">点击下单</div>
				</div>
				<div class="video-box">
					<div class="full-video" @click.stop="onVideoClick">
						<div class="full-btn">观看完整视频</div>
					</div>
					<video ref="bannerVideo" class="banner-video" preload loop muted autoplay src="https://img.hongli.xingjuju.com/yichuanghub/template/20260804/ae5409385da99c544dcf7930f8381260a6d7086c.mp4"></video>
				</div>
			</div>
			<div v-if="!is_login" class="slogan-box-un-auth">
				<img src="../../assets/images/slogan-min.png" alt="" class="slogan-img-min">
				<div class="video-box">
					<div class="full-video" @click.stop="onVideoClick">
						<div class="full-btn">观看完整视频</div>
					</div>
					<video ref="bannerVideo" class="banner-video" preload loop muted autoplay src="https://img.hongli.xingjuju.com/yichuanghub/template/20260804/ae5409385da99c544dcf7930f8381260a6d7086c.mp4"></video>
				</div>
			</div>
			<div v-if="!is_login" class="login-box">
				<div class="login-form" @keyup.enter="submit">
					<!-- <div v-if="login_mode === 'qrcode'" @click.stop="change_login_mode('form')" class="pc-btn"></div>
					<div v-else @click.stop="change_login_mode('qrcode')" class="qrcode-btn"></div> -->

					<div class="form">
						<div class="tabs">
							<div @click.stop="change_login_mode('qrcode')" :class="['tabs-btn',{active:login_mode==='qrcode'}]">扫码登录</div>
							<div @click.stop="switchFormTab('login')" :class="['tabs-btn',{active:form_scene==='login' && login_mode != 'qrcode'}]">
								账号登录</div>
							<div @click.stop="switchFormTab('register')" :class="['tabs-btn',{active:form_scene==='register' && login_mode != 'qrcode'}]">注册</div>
						</div>
					</div>
					<div v-if="login_mode === 'form'" class="form no-pt">
						<div class="form-content">
							<div class="form-item">
								<div class="mobile-prefix">+86</div>
								<input style="margin-left:10px;" v-model="form_data.mobile" placeholder="请输入手机号码" />
							</div>
							<div class="form-item" v-if="login_method === 'sms' || form_scene === 'register'">
								<input style="margin-left:20px;" v-model="form_data.code" placeholder="请输入手机验证码" />
								<sms-code class="btn-code" :mobile="form_data.mobile"></sms-code>
							</div>
							<template v-if="login_method === 'account' || form_scene === 'register'">
								<div class="form-item">
									<input style="margin-left:20px;" v-model="form_data.password" :placeholder="form_scene === 'register' ? '请设置登录密码' : '请输入登录密码'"
										:type="password_type" />
									<div style="margin-right:20px;">
										<img @click.stop="password_type = password_type =='text' ? 'password' :'text'"
											:src="password_type == 'text' ? require('../../assets/images/icon-open-eye.png'):require('../../assets/images/icon-close-eye.png')"
											style="width:18px;height:12px;" />
									</div>
								</div>
								<div v-if="login_method === 'account' && form_scene === 'login'" class="form-item">
									<input style="margin-left:20px;" v-model="form_data.captcha_code"
										placeholder="请输入右侧验证码" />
									<span class="btn-code" :style="{top:'6px',marginRight:login_method === 'account' ? '20px' : '0'}">
										<captcha class="captcha" :width="90" :height="35" :outcode.sync="captcha_code">
										</captcha>
									</span>
								</div>
							</template>
							<div style="display:flex;justify-content:space-between;align-items: center;margin-top:10px;flex:1;">
								<div v-if="form_scene === 'login'" @click.stop="login_method = login_method === 'sms' ? 'account' : 'sms'" class="login-mode">
									{{ login_method === 'sms' ? '密码登录' : '验证码登录' }}</div>
									<div style="color:#303234;font-size:14px;cursor:pointer;" @click.stop="go2find">忘记密码?</div>
							</div>
						</div>
						<div class="btn-submit" @click.stop="submit">登录</div>
						<!-- <img v-if="form_scene == 'register'" src="../../assets/images/icon-wx-login.png"
							style="width:40px;height:40px;margin-bottom:14px;cursor:pointer;" @click.stop="login_mode='qrcode'" /> -->
						<div style="color:#B1B2B3;font-size:12px;width:100%;text-align:center;">
							<p>注册登录即代表同意</p> <span class="cursor" style="color:#0d99ff;" @click.stop="open_agreement">《用户行为准则》</span>、<span class="cursor" style="color:#0d99ff;" @click.stop="open_agreement2">《设计师合作协议》 </span>
						</div>
					</div>
					<div v-if="login_mode === 'qrcode'" class="qrcode-box">
						<!-- <div class="title">微信扫一扫 注册/登录</div> -->
						<div class="qrcode-img">
							<img v-if="!!wechat_qrcode" style="width: 100%" :src="wechat_qrcode">
						</div>
						<div class="text">微信扫一扫 注册/登录查看更多优质内容</div>
					</div>
				</div>
			</div>
		</div>
		<div class="second">
			<div class="bg"></div>
			<div class="content">
				<div class="title">
					<p>专业样衣生产 全品类一站式支持</p>
					<p>多元化产品服务 为设计师品牌护航</p>
				</div>
				<div class="list">
					<img src="../../assets/images/icon-core-login.png" />
					<div class="list-item">
						<div class="item-title">核心服务：</div>
						<div class="item-content">专注为设计师提供生产样衣服务，覆盖各类服装品类，从小批量到量产都能轻松应对。</div>
					</div>
				</div>
				<div class="list">
					<img src="../../assets/images/icon-pro-login.png" />
					<div class="list-item">
						<div class="item-title">专业面辅料与自有产能：</div>
						<div class="item-content">专业面辅料资源和自有产能高效结合，全程掌控打版、缝制、质检等关键环节，确保品质稳定与交付效率。</div>
					</div>
				</div>
				<div class="list">
					<img src="../../assets/images/icon-support-login.png" />
					<div class="list-item">
						<div class="item-title">工艺与版型支持：</div>
						<div class="item-content">可选用平台自研版型库、上传自有版型，或申请专业打版服务，最大化满足设计需求。</div>
					</div>
				</div>
				<div class="list">
					<img src="../../assets/images/icon-one-step-login.png" />
					<div class="list-item">
						<div class="item-title">一站式管理：</div>
						<div class="item-content">提供完整的订单管理功能，实时追踪生产进度并支持在线协同沟通，让设计师省心省力。</div>
					</div>
				</div>
				<div class="list">
					<img src="../../assets/images/icon-money-login.png" />
					<div class="list-item">
						<div class="item-title">成果增值：</div>
						<div class="item-content">样衣完成后，可选择量产或一键上架至各大电商平台，为设计师品牌的商业化保驾护航。</div>
					</div>
				</div>
			</div>
		</div>
		<div class="third">
			<div class="third-title">简单<span>6步</span>在线下单制作专属样衣</div>
			<div class="third-content">
				<div class="content-item">
					<div class="item-num">01</div>
					<div class="item-title">新建款式设计</div>
					<div class="item-content">
						在平台上传自己设计的款式设计图,并根据要求填写定制要求的相关信息。
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-1.png" />
					</div>
				</div>
				<div class="content-item">
					<div class="item-num">02</div>
					<div class="item-title">版型来源自由选择</div>
					<div class="item-content">
						<p>1.使用平台现有版型：快速套用标准尺寸和结构 </p>
						<p>2.可上传自有版型：导入设计师已有的版型文件</p>
						<p>3.申请打版服务：由平台专业团队定制打版</p>
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-2.png" />
					</div>
				</div>
				<div class="content-item">
					<div class="item-num">03</div>
					<div class="item-title">填写工艺/面辅料需求</div>
					<div class="item-content">
						在线填写包括面料数量、缝制工艺、特殊工艺要求等，平台会自动匹配可选的供应商和生产线。
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-3.png" />
					</div>
				</div>
				<div class="content-item">
					<div class="item-num">04</div>
					<div class="item-title">确认报价并支付</div>
					<div class="item-content">
						平台根据面辅料、工艺、数量自动生成报价，设计师可查看确认后完成支付后正式下单生产。
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-4.png" />
					</div>
				</div>
				<div class="content-item">
					<div class="item-num">05</div>
					<div class="item-title">生产进度追踪</div>
					<div class="item-content">
						订单管理中心实时更新生产进度，支持与工厂在线沟通，及时处理客户变更需求。
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-5.png" />
					</div>
				</div>
				<div class="content-item">
					<div class="item-num">06</div>
					<div class="item-title">收货与评审</div>
					<div class="item-content">
						成品完成后配送上门，设计师可在线进行评审并给出反馈，为后续量产或改良提供数据支持。
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-6.png" />
					</div>
				</div>
			</div>
		</div>
		<div class="video-container" v-if="false">
			<div class="video-title-en">CORPORATE VIDEO</div>
			<div class="video-title-cn">企业视频</div>
			<div class="video-box">
				<video src="" controls="controls"></video>
			</div>
		</div>
		<div class="fourth">
			<div class="title-en">YICHUANG COMMUNITY</div>
			<div class="title-cn">衣创社区</div>
			<div class="content-box">
				<div class="item-box">
					<div class="item-num">40+<span>年</span></div>
					<div class="item-content">深耕服装行业</div>
				</div>
				<div class="item-box">
					<div class="item-num">1200<span>万</span></div>
					<div class="item-content">成衣年产量</div>
				</div>
				<div class="item-box">
					<div class="item-num">3500<span>吨</span></div>
					<div class="item-content">布匹年产量</div>
				</div>
			</div>
		</div>
		<div class="fifth">
			<div class="about-content">
				<div class="title-en">ABOUT US</div>
				<div class="title-cn">关于我们<span class="line"></span></div>
				<div class="content-box">
				<div class="fifth-content">
					<div class="title">衣创社区背后的力量</div>
					<div class="content">
						历经40多年深耕服装行业，衣创社区的背后拥有雄厚的服装全产业链资源与成熟的「智能制造」体系。
						企业自建现代化标准厂房与智能化流水线，年均产量可达1200万套成衣、3500 吨布匹，实现从纺织、绣花到成衣等多环节的高度集成，
						并不断通过研发创新和质量管控提升生产稳定性与效率，凭借过硬的产品品质、丰富的行业经验以及广泛的国内外市场布局，先后斩获多项服装制造与科技创新领域的重要荣誉。
						业务版图遍及澳洲、美国、新西兰、柬埔寨等全球重点地区，拥有自有品牌、海外营销团队及完备的海外仓储物流体系，
						与众多知名企事业单位保持长期战略合作，持续扩大全球市场份额与品牌影响力。</div>
					<div class="title">衣创社区——行业首家AI赋能的一站式服装设计与生产、销售服务平台</div>
					<div class="content">
						正是在这强大产业基础之上应运而生，旨在为服装设计师们提供一站式的创意落地与商业化支持。
						从样衣制作到柔性供应链资源的有效对接，衣创社区致力于打造开放、共享、协同的生态平台，让更多设计灵感轻松转化为高品质成品。
						我们希望与每一位热爱设计、热爱服装创新的伙伴一道，引领服装行业的创意变革，为更多品牌与个人创造更广阔的价值舞台，为行业注入源源不断的活力与价值。</div>
					</div>
				</div>
			</div>
			<div class="bg"></div>
		</div>
		<BindPhone v-if="show_bind_form" @on-close="close_popup" @on-submit="qrcode_login"></BindPhone>

		<popup :show.sync="is_popup_show" width="680px" height="520px" @on-close="close_agreement">
			<div class="agree-content">
				<div v-html="setting.userAgreement"></div>
			</div>
		</popup>

		<popup :show.sync="is_popup_show2" width="680px" height="520px" @on-close="close_agreement2">
			<div class="agree-content">
				<div v-html="setting.privacy"></div>
			</div>
		</popup>
		<create-design v-if="show_design_pop" ref="createDesign" @close-design-pop="show_design_pop=false"></create-design>
	</div>

</template>

<script>
	import {
	AccountLogin,
	GetWechatPublicQrcode,
	LoginByOpenid,
	MobileLogin,
	Profile,
	QueryOpenId,
	QueryWechat,
	Register
} from "@/api/index.js";
import BindPhone from '@/components/BindPhone/BindPhone.vue';
import Captcha from "@/components/Captcha.vue";
import CreateDesign from "@/components/CreateDesign";
import Popup from "@/components/Popup.vue";
import SmsCode from "@/components/SmsCode.vue";
import util from '@/utils/util';
import { mapState } from 'vuex';
	export default {
		name: "Login",
		components: {
			Captcha,
			SmsCode,
			BindPhone,
			Popup,
			CreateDesign
		},
		data() {
			return {
				is_popup_show: false,
				is_popup_show2: false,
				is_click: false,
				height: '600px',
				form_data: {
					mobile: '',
					code: '',
					password: '',
					captcha_code: '',
				},
				is_password_show: false,
				captcha_code: '',
				login_mode:'form',
				form_scene:'login',
				login_method:'account',
				password_type:'password',
				show_bind_form: false,
				wechat_qrcode: '',
				is_qrcode_expire: true,
				interval_id: null,
				form_data_qrcode: {
					key: '',
					openid: '',
					mobile: '',
					code: ''
				},
				back_router:'',
				back_params:{},
				show_design_pop:false
			};
		},
		computed: {
			...mapState({
				setting: (state) => state.setting,
				parent_code: (state) => state.parent_code,
				channel: (state) => state.channel,

			}),
			is_login(){
				return this.$store.state.is_login;
			}
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => {
				// 通过 `vm` 访问组件实例
				vm.$emit("changeFooter", 'original');
			});
		},
		beforeRouteLeave(to, from, next) {
			if(this.interval_id) {
				clearInterval(this.interval_id)
				this.interval_id = null
			}
			this.stopPolling();
			next();
		},
		beforeDestroy() {
			this.stopPolling();
			document.removeEventListener('fullscreenchange', this.onFullscreenChange);
		},
		mounted(){
			document.addEventListener('fullscreenchange', this.onFullscreenChange);
			if(!this.is_login){
				const {type,back_name,back_params} = this.$route.query;
				if(back_name) this.back_router = back_name;
				if(back_params) this.back_params = JSON.parse(back_params);
				if(type){
					switch(type){
						case 'phone':
							this.change_login_mode('form');
							break;
						case 'wechat':
							this.change_login_mode('qrcode')
							break;
					}
				} else {
					this.change_login_mode('qrcode')
				}
			}
		},
		created() {
			this.height = (window.innerHeight - 78) + 'px'
		},
		methods: {
			stopPolling() {
				if(this.interval_id) {
					clearInterval(this.interval_id)
					this.interval_id = null
				}
			},
			onVideoClick() {
				const video = this.$refs.bannerVideo;
				if (video) {
					video.controls = true;
					video.requestFullscreen();
				}
			},
			onFullscreenChange() {
				if (!document.fullscreenElement) {
					const video = this.$refs.bannerVideo;
					if (video) video.controls = false;
				}
			},
			onCreateDesign(){
				if(!this.is_login) return;
				if(this.setting.is_quick_design_open > 0) {
					this.show_design_pop = true
				} else {
					this.$router.push({name:'WorkBenchDesign'})
				}
			},
			close_agreement() {
				this.is_popup_show = false
			},
			open_agreement() {
				this.is_popup_show = true
			},
			close_agreement2() {
				this.is_popup_show2 = false
			},
			open_agreement2() {
				this.is_popup_show2 = true
			},
			async qrcode_login(data) {
				return LoginByOpenid({
					openid: this.form_data_qrcode.openid,
					key: this.form_data_qrcode.key,
					mobile: data.mobile,
					code: data.code,
					channel: this.channel,
					parent_code:this.parent_code
				}).then(response => {
					this.$store.commit('login', response.data)
					return Profile()
				}).then(async (response) => {
					this.$store.commit('setUserInfo', response.data)
					await localStorage.setItem('first_login', true);
					if(this.back_router){
						const param = {};
						param.name = this.back_router;
						if(this.back_params){
							param.query = this.back_params
							param.params = this.back_params;
						}
						console.log('--->back-params::',param);
						this.$router.replace(param)
					}else if(this.$route.query.redirect){
						this.$router.replace({path: this.$route.query.redirect})
					}else{
						this.$router.replace({name: 'WorkBench'})
					}
				}).catch((res)=>{
					this.$layer.msg(res.msg)
				})
			},
			close_popup() {
				this.show_bind_form = false
				this.is_qrcode_expire = true
				this.change_login_mode('qrcode')
			},
			switchFormTab(scene) {
				this.form_scene = scene
				this.change_login_mode('form')
			},
			change_login_mode(mode) {
				this.stopPolling();
				if (this.login_mode === 'qrcode' && mode !== 'qrcode') {
					this.is_qrcode_expire = true;
				}
				this.login_mode = mode
				if(mode === 'qrcode' && this.is_qrcode_expire) {
					console.log('重载qrcode');
					this.form_data_qrcode.key = util.uuid()
					GetWechatPublicQrcode({key: this.form_data_qrcode.key}).then(response => {
						this.is_qrcode_expire = false
						this.wechat_qrcode = response.data.url
						this.interval_id = setInterval(() => {
							QueryOpenId({key: this.form_data_qrcode.key}).then(res => {
								if(res.data.openid) {
									this.form_data_qrcode.openid = res.data.openid
									this.stopPolling();
									return QueryWechat({
										openid:this.form_data_qrcode.openid,
									})
								}
								return Promise.reject(-1)
							}).then(res => {
								if(res.data.is_need_bind) {
									this.show_bind_form = true
									return Promise.reject(-1)
								}
								return this.qrcode_login({})
							})
						}, 3000)
					}).catch((res)=>{
						this.$layer.msg(res.msg)
					})
				}
			},
			toggle_password() {
				this.is_password_show = !this.is_password_show;
			},
			go2find() {
				this.$router.push({name: 'FindPwd'})
			},
			submit() {
				if(this.is_click) {
					return
				}
				if(this.login_mode === 'form' && this.form_scene === 'login' && this.login_method === 'account' && this.form_data.captcha_code.length === 0) {
					this.$layer.msg(`请输入验证码`)
					return
				}
				if(this.login_mode === 'form' && this.form_scene === 'login' && this.login_method === 'account' && this.captcha_code != this.form_data.captcha_code) {
					this.$layer.msg(`验证码错误`)
					return
				}
				this.is_click = true
				let promise = new Promise(((resolve, reject) => {
					let response
					if(this.login_mode === 'form' && this.form_scene === 'login' && this.login_method === 'account') {
						response = AccountLogin(this.form_data)
						resolve(response)
					}
					if(this.login_mode === 'form' && this.form_scene === 'login' && this.login_method === 'sms') {
						response = MobileLogin(this.form_data)
						resolve(response)
					}
					if(this.login_mode === 'form' && this.form_scene === 'register') {
						this.form_data.parent_code = this.parent_code
						this.form_data.channel = this.channel
						response = Register(this.form_data);
						resolve(response)
					}
					reject({msg: `登录/注册选项异常`})
				}))
				promise.then(response => {
					this.$store.commit('login', response.data)
					return Profile()
				}).then(response => {
					this.$store.commit('setUserInfo', response.data)
				}).then(async () => {
					await localStorage.setItem('first_login', true);
					// this.$router.replace({name: 'WorkBench'})
					if(this.back_router){
						// this.$router.replace({name: this.back_router})
						const param = {};
						param.name = this.back_router;
						if(this.back_params){
							param.query = this.back_params
							param.params = this.back_params;
						}
						console.log('--->back-params::',param);
						this.$router.replace(param)
					}else if(this.$route.query.redirect){
						this.$router.replace({path: this.$route.query.redirect})
					}else{
						this.$router.replace({name: 'WorkBench'})
					}
				})
				promise.catch((res)=>{
					this.$layer.msg(res.msg)
				})
				promise.finally(() => {
					this.is_click = false
				})
			},
		},
	};
</script>

<style scoped lang="scss">
@import './login.scss';
</style>
